<template>
  <div v-if="visible" id="card-asset">
    <div class="panel panel-default contact-card card-view">
      <div class="panel-heading bg-white">
        <div class="row card-row">
          <div class="col-sm-2 mr-2 icon-field">
            <div>
              <i class="circle">
                <img class="card-user-img icon" :src="`${imagePath}`" v-if="isImage">
                <span v-if="isAudio" class="icon audio">
                  <i class="fa fa-music"></i>
                </span>
                <span v-else-if="!isImage && !isAudio" class="icon audio">
                  <i class="fa fa-file"></i>
                </span>
              </i>
            </div>
          </div>
          <div class="col-sm-10">
            <div class="asset-detailes">
              <div class="asset-name">
                <span class="name-field">{{ asset.file_name }}</span>
                <a class="pull-right action-button">
                  <i class="ti-close" @click="deleteAsset(asset.id)"></i>
                </a>
              </div>
              <span class="block overflow-text size-field">
                <span>{{ asset.file_size }}</span>
              </span>
            </div>
          </div>
          <div class="pull-right"></div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardAsset",
  props: {
    asset: {
      type: Object,
      required: true
    },
    labelValue: {
      type: String,
      default: ""
    },
    imagePath: {
      type: String,
      default: "static/image_placeholder.png"
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  },
  computed: {
    isImage() {
      return this.asset.content_type.includes("image");
    },
    isAudio() {
      return this.asset.content_type.includes("audio");
    }
  },
  created() {},
  methods: {
    deleteAsset(id) {
      this.$emit("deleteAsset", id);
    }
  }
};
</script>

<style lang="scss" scoped>
#card-asset {
  .card-row {
    display: flex;
    align-items: center;
  }
  .circle {
    border-radius: 50%;
    border: 1px solid var(--main-color);
    font-size: 25px;
    text-align: center;
    display: inline-block;
    margin: 14px;
  }

  .icon {
    border-radius: 50%;
    height: 50px !important;
    width: 50px !important;
    &.audio {
      height: auto !important;
    }
  }

  .decreased-padding {
    padding-left: 5px;
  }

  .size-field {
    font-size: 11px;
  }

  .asset-detailes,
  .asset-name {
    padding-bottom: 5px;
  }

  .action-button {
    margin-top: 0px !important;
    cursor: pointer;
  }

  .icon-field {
    min-width: 20%;
  }

  img {
    display: block;
  }

  span {
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/inputs/AssetCard.vue